/**
 * Password Page
 * ------------------------------------------------------------------------------
 * Login modal for the password page
 *
 */

import $ from 'jquery';
import { modal } from './../exports/modals';

(function() {
  var $toggleLogin = $('.js-toggle-login-modal');
  if ($toggleLogin.length) {
    passwordPage();
  }
})();

function passwordPage() {
  modal('password');
  if ($('.storefront-password-form .errors').length) {
    $('.js-toggle-login-modal').click();
  }
}
